module.exports = __webpack_public_path__ + "img/ar.51c7aeb.svg";